import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export const Team = () => {
  const teamMembers = [{
    id: 'andrew-igbineweka',
    name: 'Andrew Igbineweka',
    role: 'Founder',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2e91tcJdXJukNhGR3YoR4c/Andrew_Igbineweka%2C_Founder_.jpg',
    brief: "Andrew moves through the world with the steadiness of someone who understands that ideas only matter when they are built into systems that change people's lives. As a Learning Experience Designer and Digital Learning Strategist, he has spent more than seven years building learning ecosystems that help individuals and organizations adapt to a world increasingly defined by AI and digital innovation."
  }, {
    id: 'precious-obayuwana',
    name: 'Precious Obayuwana',
    role: 'Chief Operations Officer',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tiuzezKDFtcTj9dbiEA2Tq/Precious_Obayuwana%2C_Chief_Operations_Officer.jpg',
    brief: 'Precious brings a rare kind of operational clarity—the kind that steadies an organization, sharpens its rhythm, and turns vision into grounded, repeatable excellence. Her work sits at the heart of systems, people, and purpose, yet her impact is felt in the quiet confidence she brings into every room: things will work, people will grow, and the mission will move.'
  }, {
    id: 'bibi-eneje',
    name: 'Bibi Eneje',
    role: 'Chief Growth Officer',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7u76HdqRGggPRPNySjG8aG/Bibi_Eneje%2C_Chief_Growth_Officer.png',
    brief: 'Bibi enters a room the way a catalyst enters a reaction—subtle at first, then quietly transformative. Her work sits at the crossroads of storytelling, culture shaping, and strategic influence, and she carries the rare ability to turn scattered potential into structured momentum. Growth, in her hands, is not a department. It is an ecosystem.'
  }, {
    id: 'bella-ojoka',
    name: 'Bella Ojoka',
    role: 'Programs and Community Lead',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vy2d386bQZ37DRZ67avafS/Bella_Ojoka%2C_Programs_and_Community_Lead.jpg',
    brief: "Bella carries a kind of steadiness that makes complex work feel possible. Her mind is analytical, her heart is people-centered, and her craft lives in the space where data, strategy, and human transformation meet. She is the kind of leader who doesn't just run programs—she architects experiences that move people forward."
  }, {
    id: 'george-ozigagu-topa',
    name: 'George Ozigagu Topa',
    role: 'Human Resources Lead',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7NPfEGqqSwbJWuP8w8bnhB/George_Ozigagu_Topa%2C_Human_Resources.jpg',
    brief: 'George is the kind of HR leader every growing ecosystem needs—measured, intuitive, and deeply committed to the science and soul of people. He understands that culture is not created by accident; it is engineered through clarity, trust, and the right talent in the right roles.'
  }, {
    id: 'maxwell-orioko',
    name: 'Maxwell Orioko',
    role: 'Content & Design Lead',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ted3p6u8tzPPN9kZoNtuEk/Maxwell_Orioko%2C_Content_and_Design_Lead.jpg',
    brief: 'Maxwell is the visual mind of the ecosystem—the one who turns ideas into identity, concepts into form, and strategy into imagery that lingers long after the room has emptied. His work threads together graphic design, digital storytelling, and AI-powered visual creation, giving The Networking Salon its unmistakable aesthetic rhythm: sharp, intentional, and deeply human.'
  }];
  return <div className="pt-20 bg-white" data-id="element-4836" data-mp="3ttwlwl8q0qrn">
      {/* Hero Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-4837" data-mp="3othc23nne1ef">
        <div className="container mx-auto px-4" data-id="element-4838" data-mp="1spaxvma5ta6u">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4839" data-mp="1sqmbsexbjybo">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" data-id="element-4840" data-mp="1xp71hkey2zlv">
              Meet Our Team
            </h1>
            <p className="text-xl text-gray-600" data-id="element-4841" data-mp="1iz83piraxq6x">
              The passionate individuals behind The Networking Salon, dedicated
              to building connections and creating opportunities.
            </p>
          </div>
        </div>
      </section>
      {/* Team Members - Alternating Layout */}
      <section className="py-16" data-id="element-4842" data-mp="1e2hsp9uctksd">
        <div className="container mx-auto px-4" data-id="element-4843" data-mp="1dylmaissdt2g">
          <div className="max-w-6xl mx-auto space-y-16" data-id="element-4844" data-mp="1026x5ti3ni0v">
            {teamMembers.map((member, index) => {
            const isEven = index % 2 === 0;
            return <div key={member.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${isEven ? '' : 'lg:grid-flow-dense'}`} data-id="element-4845" data-mp="2uewu6k3rl7ch" data-mpi={index}>
                  {/* Image */}
                  <div className={`${isEven ? '' : 'lg:col-start-2'} flex justify-center`} data-id="element-4846" data-mp="nrpd70wj1rx2">
                    <div className="relative w-64 h-64 md:w-80 md:h-80" data-id="element-4847" data-mp="iq02jmd7vg9i">
                      <div className="absolute inset-0 border-2 border-gray-300 rounded-full" data-id="element-4848" data-mp="xiab0m4dmsex"></div>
                      <img src={member.image} alt={member.name} className="w-full h-full rounded-full object-cover grayscale hover:grayscale-0 transition-all duration-300" loading="lazy" data-id="element-4849" data-mp="sofxy1ja1bot" />
                    </div>
                  </div>
                  {/* Content */}
                  <div className={`${isEven ? '' : 'lg:col-start-1 lg:row-start-1'} ${isEven ? 'lg:text-left' : 'lg:text-right'}`} data-id="element-4850" data-mp="1bhtidcpd5zq6">
                    <h2 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-4851" data-mp="3d8n3sgm19b63">
                      {member.name}
                    </h2>
                    <p className="text-xl text-gray-600 font-medium mb-6" data-id="element-4852" data-mp="6s7hmruo3xzj">
                      {member.role}
                    </p>
                    <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-4853" data-mp="frazxtm0g9cz">
                      {member.brief}
                    </p>
                    <Link to={`/team/${member.id}`} className={`inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-800 rounded-md text-gray-800 font-medium hover:bg-gray-800 hover:text-white transition-colors duration-300 ${isEven ? '' : 'lg:flex-row-reverse'}`} data-id="element-4854" data-mp="kqnw54yruss8">
                      <span data-id="element-4855" data-mp="yikjywteqgit">Learn More</span>
                      <ArrowRight size={16} data-id="element-4856" data-mp="13hf1zwjjw11v" />
                    </Link>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>
      {/* Join Team CTA */}
      <section className="py-16 bg-gray-50 border-t border-gray-200" data-id="element-4857" data-mp="1dg4ndzano3mv">
        <div className="container mx-auto px-4" data-id="element-4858" data-mp="2xwubm15xc8q6">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4859" data-mp="2xyoxpisxm6vu">
            <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-4860" data-mp="2sxhqbkupb9pp">
              Join Our Team
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-4861" data-mp="2ny4tc7a48m9e">
              We're always looking for passionate individuals to join our
              mission. Explore opportunities to contribute to our growing
              community.
            </p>
            <Link to="/join-team" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-800 rounded-md text-gray-800 font-medium hover:bg-gray-800 hover:text-white transition-colors duration-300" data-id="element-4862" data-mp="3gmtv88izwvm7">
              View Open Positions
              <ArrowRight size={16} className="ml-2" data-id="element-4863" data-mp="31yfk7abfe0uk" />
            </Link>
          </div>
        </div>
      </section>
    </div>;
};